import { useEffect } from "react";
import CompanyView from "./CompanyView";
import { useCompany } from "models/companies/apiCompany";
import { useLogHistory } from "models/history/apiHistory";

const CompanyViewAsCard = ({ companyId }) => {
  const { data: company, isSuccess, isError } = useCompany(companyId);
  const handleLog = useLogHistory("app.company");
  useEffect(() => {
    isSuccess && handleLog(company.id);
  }, [company?.id, isSuccess]);
  if (isError) return <>Error</>;
  if (!isSuccess) return <></>;

  return <CompanyView company={company} />;
};

export default CompanyViewAsCard;
